import moment from 'moment';
import React, { useEffect, useContext, useState } from 'react';
import Page from '../../../components/Page';
import PaginatedList from '../../../components/PaginatedList';
import useAPI from '../../../hooks/useAPI';
import AuthContext from '../../../contexts/AuthContext';
import RoundedButton from '../../../components/RoundedButton';

export default function PaymentOverview (props) {
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [orderBy, setOrderBy] = useState('payment_date');
    const [orderDir, setOrderDir] = useState('desc');

    const api = useAPI();
    const { system } = useContext(AuthContext);

    const loadPayments = ()=>{
        setLoading(true);

        api.json('GET', '/systems/' + system.id + '/payments', { order_by: orderBy, order_dir: orderDir })
           .then(r=>r.json())
           .then(response=>{
                if(!response.data){
                    return
                }

                setPayments(response.data || []);
           })
           .catch(()=>alert('Unable to load payments.'))
           .then(()=>setLoading(false));
    }

    useEffect(()=>{
        loadPayments();
        // eslint-disable-next-line
    }, [orderBy, orderDir]);

    return (
        <Page
            title="Payments"
            busy={loading}
            headerItem={(
                system.is_owner ?
                    <RoundedButton onClick={(e) => {
                        e.preventDefault();
                        window.open('https://srechelp.carbonsolutionsgroup.com/hc/en-us/requests/new?ticket_form_id=6883045103892', '_blank');
                    }}>
                        Payment Re-issue Request
                    </RoundedButton>
                    : null
            )}
        >
            <div className='row'>
                {payments.length ? (
                    <div className='col-12'>
                        <PaginatedList
                            order={(orderByKey, orderByDir) => {
                                setOrderBy(orderByKey);
                                setOrderDir(orderByDir);
                            }}
                            activeOrder={orderBy}
                            dir={orderDir}
                            headers={[
                                { order_key: 'identifier', label: 'Id' },
                                'Description',
                                { order_key: 'recs', label: 'RECs' },
                                { order_key: 'payment_period', label: 'Generation Period' },
                                { order_key: 'method', label: 'Payment Method' },
                                { order_key: 'status', label: 'Status' },
                                { order_key: 'payment_date', label: 'Payment Date' },
                                { order_key: 'amount', label: 'Amount' }
                            ]}
                            items={payments}
                            render={(payment) => {
                                let statusStyle = { fontWeight: 600 };
                                if (payment.status && payment.status.toLowerCase() === 'paid') {
                                    statusStyle.color = '#1EB88B';
                                }

                                const recs = payment.recs ? (
                                    payment.recs.toLocaleString() + ' REC' + (payment.recs !== 1 ? 's' : '')
                                ) : '-';

                                const paymentDate = payment.payment_date
                                    ? moment(payment.payment_date, ['YYYY-MM-DD', 'M/D/YYYY', 'MM/DD/YYYY']).format('MMM DD, YYYY')
                                    : '-';

                                return (
                                    <>
                                        <td><span>{payment.identifier}</span></td>
                                        <td><span>{payment.description}</span></td>
                                        <td><span style={{ fontWeight: 600 }}>{recs}</span></td>
                                        <td><span>{payment.generation_period || '-'}</span></td>
                                        <td><span>{payment.method}</span></td>
                                        <td><span style={statusStyle}>{payment.status || '-'}</span></td>
                                        <td><span>{paymentDate}</span></td>
                                        <td style={{ fontWeight: 600, color: '#1EB88B' }}>
                                            <span>${(payment.amount_formatted || payment.amount)}</span>
                                        </td>
                                    </>
                                );
                            }}
                        />
                    </div>
                ) : (
                    loading ? null : (
                        <div style={{ display: 'flex', padding: 40, flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                            <span>No Payments Applicable</span>
                        </div>
                    )
                )}
            </div>
        </Page>
    );
};